import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { TranslateModule } from '@ngx-translate/core';

type PromoCardType = {
  title: string,
  images: {
    promoCardPersonImg: string,
    promoCardIcon1Img: string,
    promoCardIcon2Img: string
  }
}

@Component({
  selector: 'app-promo-card',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './promo-card.component.html',
  styleUrl: './promo-card.component.css',

  animations: [
    trigger('fadeSlider', [
      transition('* => *', [
        style({
          opacity: 0,
          transform: 'translateY(12px)'
        }),
        animate(
          '600ms ease-in-out',
          style({
            opacity: 1,
            transform: 'translateY(0)'
          })
        )
      ])
    ])
  ]
})
export class PromoCardComponent implements OnInit {

  promoCardIndex = 0;
  intervalId!: ReturnType<typeof setInterval>;

  promoCards: PromoCardType[] = [
    {
      title: "auth.promo_cards.card1",
      images: {
        promoCardPersonImg: 'auth/promo-card/promo-card-1-person.svg',
        promoCardIcon1Img: 'auth/promo-card/promo-card-1-icon-1.png',
        promoCardIcon2Img: 'auth/promo-card/promo-card-1-icon-2.png',
      },
    },
    {
      title: "auth.promo_cards.card2",
      images: {
        promoCardPersonImg: 'auth/promo-card/promo-card-2-person.svg',
        promoCardIcon1Img: 'auth/promo-card/promo-card-2-icon-1.png',
        promoCardIcon2Img: 'auth/promo-card/promo-card-2-icon-2.png',
      }
    },
    {
      title: "auth.promo_cards.card3",
      images: {
        promoCardPersonImg: 'auth/promo-card/promo-card-3-person.svg',
        promoCardIcon1Img: 'auth/promo-card/promo-card-3-icon-1.png',
        promoCardIcon2Img: 'auth/promo-card/promo-card-3-icon-2.png',
      }
    },
  ];

  ngOnInit(): void {
    this.startSlider();
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalId);
  }

  startSlider(): void {
    clearInterval(this.intervalId);
    this.intervalId = setInterval(() => {
      this.nextSlide();
    }, 5000);
  }

  nextSlide(): void {
    this.promoCardIndex =
      (this.promoCardIndex + 1) % this.promoCards.length;
  }

  goToSlide(index: number): void {
    this.promoCardIndex = index;
    this.startSlider();
  }

}
